export const ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  APP_ADMIN:'APP_ADMIN',
  SCHOOL_ADMIN: 'SCHOOL_ADMIN',
  ADMIN:'ADMIN',
  STUDENT: 'STUDENT',
  TEACHER: 'TEACHER',
  LIBRARIAN:'LIBRARIAN',
  COACH:'COACH',
  STAFF:'STAFF',
  FINANCE_ADMIN: 'FINANCE_ADMIN',
  EXAMS_ADMIN:'EXAMS_ADMIN'
};
